import React from "react";
import Downshift from "downshift";
import PropTypes from "prop-types";
import {escapeRegexCharacters} from "../utils";
import {PlainSelectMenu} from "./menu";


class Autocomplete extends React.Component {
    static propTypes = {
        items: PropTypes.arrayOf(PropTypes.object),
        itemsGetter: PropTypes.func,
        id: PropTypes.string,
        name: PropTypes.string.isRequired,
        value: PropTypes.string,
        placeholder: PropTypes.string,
        onChange: PropTypes.func.isRequired,
        onSelect: PropTypes.func,
        itemToString: PropTypes.func
    };

    static defaultProps = {
        items: [],
        value: '',
        itemToString: (obj) => (obj ? obj.label : '')
    };

    state = {items: []};

    handleChange = (selectedItem) => {
        if (this.props.onSelect)
            this.props.onSelect({target: {name: this.props.name, value: selectedItem}});
        if (this.props.itemsGetter) // ie when state.items should change at all
            this.setState({items: []});
    };

    handleInputValueChange = async (value) => {
        if (value === this.props.value) return; // don't do double update in case handleChange already handles value change
        if (this.props.onChange)
            this.props.onChange({target: {name: this.props.name, value}});
        if (this.props.itemsGetter) {
            const items = await this.props.itemsGetter(escapeRegexCharacters(value.trim()));
            this.setState({items});
        }
    };

    stateReducer(state, changes) {
        switch (changes.type) {
            case Downshift.stateChangeTypes.blurInput: // TAB navigation
            case Downshift.stateChangeTypes.mouseUp: // click outside
            case Downshift.stateChangeTypes.keyDownEscape: // ESC press
                // because selectedItem={null} and itemToString(null) returns '', changes.inputValue is ''
                return {...changes, inputValue: state.inputValue};
            default:
                return changes;
        }
    };

    render() {
        const {placeholder, itemToString, name, value} = this.props;
        const id = this.props.id || name;
        const items = this.props.itemsGetter ? this.state.items : this.props.items;

        return (
            <Downshift stateReducer={this.stateReducer} selectedItem={null} itemToString={itemToString}
                       inputValue={value} onChange={this.handleChange} onInputValueChange={this.handleInputValueChange}>
                {({getMenuProps, getInputProps, getItemProps, isOpen, highlightedIndex}) =>
                    <div className="custom-select">
                        <input {...getInputProps({
                            type: "text",
                            className: 'form-input',
                            id,
                            name,
                            value,
                            placeholder
                        })}/>
                        {isOpen && items.length > 0 &&
                            <PlainSelectMenu matchingItems={items} getMenuProps={getMenuProps}
                                             getItemProps={getItemProps}
                                             highlightedIndex={highlightedIndex} selectedItems={null}
                                             itemToString={itemToString}
                                             multi={false}
                            />
                        }
                    </div>}
            </Downshift>
        );
    }
}

export default Autocomplete;